import React, { useState } from 'react';
import axios from "axios";
import { Link, useNavigate  } from 'react-router-dom'
import { linksurl } from '../../../apis/urls'

const AddLinks = () =>{

  const [link_text,setLink_text] = useState('');
  const [link_url,setLink_url] = useState('');
  const [link_target,setLink_target] = useState('');
  const [status,setStatus] = useState('');

  const [linktexter,setLinktexter] = useState(false);
  const [linkurler,setLinkurler] = useState(false);
  const [linktargeter,setLinktargeter] = useState(false);

  let navigate = useNavigate();
  const RoutToList = () =>{

      let path = 'newPath'; 
      navigate("/links")
      
  }


  const onFormClick = () => {
      
        let error = 0;

        if(link_text === '')
        {
            setLinktexter(true)
            error = 1;
        }
        if(link_url === '')
        {
            setLinkurler(true)
            error = 1;
        }
        // if(link_target === '')
        // {
        //     setLinktargeter(true)
        //     error = 1;
        // }

        if(error === 0)
        {

            let token = "Bearer "+localStorage.getItem('token');
            console.log(token)
            const data = {
                link_text:link_text,
                link_url:link_url,
                link_target:"_blank",
                status :'ACTIVE'
            }
            
            const instance = axios.create({

                baseURL: linksurl,

                timeout: 1000000,

                headers: {'authorization': token}

                });
                
                instance.post('',data).then((response) =>{
                
                let path = 'newPath'; 
                navigate("/links")
                
                }).catch((error) =>{
                
                //console.log('error',error.message)

               // setNameerror('Enter the Name')
                

            });
        }



  }


    return(
        <div className="wrapper">
            <aside className="right-side ">
            <div className="content-area">
            <div className="page-title-wrpr">
                <div className="page-title-left-column">  
                    <h2 className="page-title">Add Links</h2>
                </div>
                <div className="page-rightside-action-column">
                </div>
            </div>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                <li className="breadcrumb-item"><Link to="/links">Links</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Add Link</li>
              </ol>
            </nav>
            <div className="form-wrpr">
                <div className="card formcard small">
                    <div className="card-body">
                      <form>
                        <div className="form-group">
                            <label className="degreehead">Link Title <span style={{color: "red"}}>*</span></label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" 
                            placeholder="Enter Link Title" 
                            id="link_text" 
                            value={link_text}
                            onChange={e => setLink_text(e.target.value)} />

                            {
                                linktexter
                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Link Text</div>
                                :null
                            }

                        </div>
                        <div className="form-group">
                            <label className="degreehead">URL <span style={{color: "red"}}>*</span></label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" 
                            placeholder="Enter URL" 
                            id="link_url" 
                            value={link_url}
                            onChange={e => setLink_url(e.target.value)}  />

                            {
                                linkurler
                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The URL</div>
                                :null
                            }

                        </div>
                        {/* <div className="form-group">
                            <label className="degreehead">Link Target <span style={{color: "red"}}>*</span></label>
                            <select type="password" class="form-control bg-dark"
                                        id="state"
                                        value={link_target}
                                        onChange={e => setLink_target(e.target.value)} 
                                        >
                                        <option>Select Status</option>
                                        <option>_blank</option>
                                        <option>_self</option>
                                        <option>_parent</option>
                                        <option>_top</option>
                                    </select>

                                    {
                                        linktargeter
                                        ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Select the Target</div>
                                        :null
                                    }
                        </div> */}
                        {/* <div className="form-group">
                            <label className="degreehead">Status</label>
                            <select type="password" class="form-control bg-dark"
                                        id="state"
                                        value={status}
                                        onChange={e => setStatus(e.target.value)} 
                                        >
                                        <option>Select Status</option>
                                        <option>ACTIVE</option>
                                        <option>INACTIVE</option>
                                        <option>DELETED</option>
                                    </select>
                        </div> */}
                        <h6 style={{color: "red"}}>* Required Fields</h6>
                        
                        <div className="form-group text-right">
                        <button className="btn btn-primary btn-gisa cancelbtn" onClick={RoutToList} type="submit">Cancel</button>
                            <button className="btn btn-primary btn-gisa" type="button"   onClick={onFormClick}>Create</button>
                        </div>
                        </form>
                    </div>
                </div>
                
            </div>
            
        </div>
            </aside>
        </div>
    )
}

export default AddLinks;